import React, { useState } from "react";
import s from "./SelectableProductCard.module.css";
import { DeleteIcon, TickIcon } from "../../../../../utils/Icons";

export default function SelectableProductCard({
    product,
    selected,
    onToggle,
    onDelete,
    children,
    disabled = false,
}) {
    const [hovered, setHovered] = useState(false);

    const handleClick = () => {
        if (disabled) return;
        onToggle?.();
    };

    const handleKeyDown = (e) => {
        if (disabled) return;
        if (e.key === "Enter" || e.key === " ") onToggle?.();
    };

    return (
        <div
            className={`${s.wrap} ${selected ? s.selected : ""} ${disabled ? s.disabled : ""}`}
            onClick={handleClick}
            role="button"
            tabIndex={disabled ? -1 : 0}
            onMouseEnter={() => !disabled && setHovered(true)}
            onMouseLeave={() => !disabled && setHovered(false)}
            onKeyDown={handleKeyDown}
        >
            {/* Top-right tools (hidden while disabled unless already selected) */}
            {!disabled && (
                <div className={s.topBtns} aria-hidden>
                    <button
                        className={s.deleteBtn}
                        title="Remove from collection"
                        onClick={(e) => {
                            e.stopPropagation();
                            onDelete?.();
                        }}
                    >
                        <DeleteIcon height={18} fill="var(--secondary-color)" />
                    </button>

                    {selected ? (
                        <div className={s.tick}>
                            <TickIcon height={12} fill="white" />
                        </div>
                    ) : (
                        <div className={s.Notticked}></div>
                    )}
                </div>
            )}

            {children}
        </div>
    );
}
